import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text, Button } from '@grandvisionhq/elements';
import AvailabilityCalendar from '../AvailabilityCalendar/AvailabilityCalendarContainer.js';
import NoTimeSlots from '../NoTimeSlots/NoTimeSlotsContainer.js';
import { Variant } from '../NoTimeSlots/types.js';
import PreferredTime from '../PreferredTime/PreferredTimeContainer.js';
import TimeSlots from '../TimeSlots/TimeSlotsContainer.js';
import SelectedTypeContainer from './SelectedType/SelectedTypeContainer.js';

const DropInWidget = ({ className , urls , loading , labels , store , type , noTimeSlotsVariant , timeSlots , calendarLoading , calendarWeekDate , calendarWeekCount , calendarClosedDates , calendarAvailability , selectedDate , timeSlotsLoading , nextAvailableDate , noMoreAvailabilityUntilDate , selectedTimeSlot , preferredTimeLabels , onCalendarWeeksChange , onSelectDate , onSelectTime , noTimeSlotsAction , onBookAppointment , onSelectedTypeContainerClick ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('aab-drop-in-widget', {
            'aab-drop-in-widget--loading': loading,
            'aab-drop-in-widget--expanded': selectedDate !== undefined
        }, className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "aab-drop-in-widget__title"
    }, labels.title), /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__date",
        className: "aab-drop-in-widget__section"
    }, /*#__PURE__*/ React.createElement(PreferredTime, {
        labels: preferredTimeLabels,
        calendar: /*#__PURE__*/ React.createElement(AvailabilityCalendar, {
            "aria-controls": "aab-drop-in-widget__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            closedDates: calendarClosedDates,
            availability: calendarAvailability,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate
        })
    })), selectedDate ? /*#__PURE__*/ React.createElement(React.Fragment, null, store && type && /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__type",
        className: "aab-drop-in-widget__section"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "aab-drop-in-widget__section-title"
    }, labels.type), /*#__PURE__*/ React.createElement(SelectedTypeContainer, {
        urls: urls,
        store: store,
        type: type,
        onClick: onSelectedTypeContainerClick
    })), /*#__PURE__*/ React.createElement("section", {
        id: "aab-drop-in-widget__timeslots",
        className: "aab-drop-in-widget__timeslots aab-drop-in-widget__section",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "aab-drop-in-widget__section-title"
    }, labels.selectATime), noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(TimeSlots, {
        loading: timeSlotsLoading,
        slots: timeSlots,
        selected: selectedTimeSlot,
        onSelectTime: onSelectTime
    }) : /*#__PURE__*/ React.createElement(NoTimeSlots, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }))) : null, /*#__PURE__*/ React.createElement(Button, {
        className: "aab-drop-in-widget__book-appointment-button",
        variant: "solid",
        onClick: onBookAppointment,
        disabled: loading || !store
    }, labels.bookAppointment))
;
var DropInWidget$1 = DropInWidget;

export { DropInWidget, DropInWidget$1 as default };
//# sourceMappingURL=DropInWidget.js.map
